
const config = {
  projectName: ``,
  redirectUrl: `${process.env.VUE_APP_REDIRECT_URL}`, // 项目地址
  baseUrl: `${process.env.VUE_APP_BASE_URL}`, // 项目地址
  baseApi: `${process.env.VUE_APP_BASE_API}`, // 本地api请求地址
  appid: `${process.env.VUE_APP_APPID}`, // 本地api请求地址
  appEnv: `${process.env.VUE_APP_ENV}`,
  staticImg: `${process.env.VUE_APP_BASE_OSS}`,
  baseTwo: `${process.env.VUE_APP_BASE_TWO}`,
  isYp: `${process.env.VUE_APP_BASE_ISYP}`
}

export default config
